import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

const V = ({value}) => <>{value === null || value === undefined || value === '' ? '0' : value}</>;
const formatTimes = (times = []) => {
    const validTimes = times.filter((time) => time !== null && time !== undefined && String(time).trim() !== '');
    return validTimes.length ? validTimes.join('   |   ') : '0';
};

export default () => {
    let page = useContext(RecordsManagementContext).IV3_PageDetails || {};
    let move = page.NcBolMoveChargeData || {};
    let sit = page.NcBolStorageInTransit || {};
    let sitDateLabel = sit.sit_date_label || 'MM-DD-YYYY';
    let packing = page.NcBolPackingAdditionalChargeData || {};
    let summary = page.NcBolSummaryData || {};
    let rows = packing.rows || [];
    let currency = page.Currency || '$';

    return (
        <div className='ncbol-charge-wrap mt-2'>
            <div className='ncbol-charge-scroll'>
                <table className='table mb-0 ncbol-charge-table'>
                    <thead>
                    <tr className='ncbol-black-head'>
                        <th colSpan={6}>HOURLY (local): MOVES UNDER 50 MILES</th>
                        <th colSpan={6}>WEIGHT/DISTANCE (W/D): MOVES OVER 50 MILES</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className='ncbol-cell-label'>MOVE START</td>
                        <td className='ncbol-cell-val' colSpan={5}>{formatTimes(move.move_start_times || [])}</td>
                        <td className='ncbol-cell-label' colSpan={2}>GROSS lbs.</td>
                        <td className='ncbol-cell-val'><V value={move.gross_lbs}/></td>
                        <td className='ncbol-cell-label' colSpan={2}>FUEL RATE</td>
                        <td className='ncbol-cell-val'><V value={move.fuel_rate}/></td>
                    </tr>
                    <tr>
                        <td className='ncbol-cell-label'>MOVE END</td>
                        <td className='ncbol-cell-val' colSpan={5}>{formatTimes(move.move_end_times || [])}</td>
                        <td className='ncbol-cell-label' colSpan={2}>TARE lbs.</td>
                        <td className='ncbol-cell-val'><V value={move.tare_lbs}/></td>
                        <td className='ncbol-cell-label' colSpan={2}>FUEL SURCHARGE {currency}</td>
                        <td className='ncbol-cell-val'><V value={move.fuel_surcharge}/></td>
                    </tr>
                    <tr>
                        <td className='ncbol-cell-label'>Regular Hours</td>
                        <td className='ncbol-cell-val'><V value={move.regular_hours}/></td>
                        <td className='ncbol-cell-val'><V value={move.regular_crew_vehicles}/></td>
                        <td className='ncbol-cell-val'><V value={move.regular_rate}/></td>
                        <td className='ncbol-cell-val' colSpan={2}><V value={move.regular_total}/></td>
                        <td className='ncbol-cell-label' colSpan={2}>NET lbs.</td>
                        <td className='ncbol-cell-val'><V value={move.net_lbs}/></td>
                        <td className='ncbol-cell-label' colSpan={2}>ONE-WAY MILES:</td>
                        <td className='ncbol-cell-val'><V value={move.one_way_miles}/></td>
                    </tr>
                    <tr>
                        <td className='ncbol-cell-label'>Overtime Hours</td>
                        <td className='ncbol-cell-val'><V value={move.overtime_hours}/></td>
                        <td className='ncbol-cell-val'><V value={move.overtime_crew_vehicles}/></td>
                        <td className='ncbol-cell-val'><V value={move.overtime_rate}/></td>
                        <td className='ncbol-cell-val' colSpan={2}><V value={move.overtime_total}/></td>
                        <td className='ncbol-cell-label' colSpan={3}></td>
                        <td className='ncbol-cell-label' colSpan={2}>HAUL RATE per 100:</td>
                        <td className='ncbol-cell-val'><V value={move.haul_rate_per_100}/></td>
                    </tr>
                    <tr>
                        <td className='ncbol-cell-label' colSpan={3}>Travel Time: (1 HR per 50-miles or fraction thereof)</td>
                        <td className='ncbol-cell-val'><V value={move.travel_rate}/></td>
                        <td className='ncbol-cell-val' colSpan={2}><V value={move.travel_total}/></td>
                        <td className='ncbol-cell-label' colSpan={2}>BREAK POINT lbs.</td>
                        <td className='ncbol-cell-val'><V value={move.break_point_lbs}/></td>
                        <td className='ncbol-cell-label' colSpan={2}>HAUL TOTAL {currency}:</td>
                        <td className='ncbol-cell-val'><V value={move.haul_total}/></td>
                    </tr>
                    <tr>
                        <td colSpan={6} className='ncbol-cell-subnote'></td>
                        <td colSpan={6} className='ncbol-cell-subnote'>BINDING WEIGHT: SUBJECT TO MRT RULES (14/21/23/24/25/29)</td>
                    </tr>
                    <tr>
                        <td colSpan={6}></td>
                        <td className='ncbol-cell-label' colSpan={3}>SHIPMENT MOVING AT SET lbs.:</td>
                        <td className='ncbol-cell-val' colSpan={3}><V value={move.shipment_moving_set_lbs}/></td>
                    </tr>
                    <tr>
                        <td colSpan={6} className='ncbol-cell-red'>TOTAL HOURLY CHARGES: {currency}<V value={move.total_hourly_charges}/></td>
                        <td colSpan={6} className='ncbol-cell-red'>TOTAL LINEHAUL CHARGES: {currency}<V value={move.total_linehaul_charges}/></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className='ncbol-charge-scroll'>
                <table className='table mb-0 mt-1 ncbol-charge-table'>
                    <thead>
                    <tr className='ncbol-black-head'>
                        <th colSpan={12}>(SIT) STORAGE-IN-TRANSIT - To / From Warehouse (Less than 180-days)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className='ncbol-cell-label'>Lbs. IN:</td><td className='ncbol-cell-val'><V value={sit.lbs_in}/></td>
                        <td className='ncbol-cell-label'>Lbs. OUT:</td><td className='ncbol-cell-val'><V value={sit.lbs_out}/></td>
                        <td className='ncbol-cell-label'>RATE/100:</td><td className='ncbol-cell-val'><V value={sit.storage_rate}/></td>
                        <td className='ncbol-cell-label'>{currency} SIT-HAUL CHARGE:</td><td className='ncbol-cell-val'><V value={sit.sit_haul_charge}/></td>
                        <td className='ncbol-cell-label'>{currency} WAREHOUSE HANDLING CHARGE (once):</td><td className='ncbol-cell-val'><V value={sit.warehouse_handling_charge}/></td>
                        <td className='ncbol-cell-label' colSpan={2}></td>
                    </tr>
                    <tr>
                        <td className='ncbol-cell-label'>{sitDateLabel}:</td><td className='ncbol-cell-val'><V value={sit.lbs_in_date}/></td>
                        <td className='ncbol-cell-label'>{sitDateLabel}:</td><td className='ncbol-cell-val'><V value={sit.lbs_out_date}/></td>
                        <td className='ncbol-cell-label'>#MONTHS:</td><td className='ncbol-cell-val'><V value={sit.storage_months}/></td>
                        <td className='ncbol-cell-label'>{currency} STORAGE CHARGE:</td><td className='ncbol-cell-val'><V value={sit.storage_charge}/></td>
                        <td className='ncbol-cell-label'>{currency} EXTENDED VALUATION (15% of FVP / Month):</td><td className='ncbol-cell-val'><V value={sit.extended_valuation}/></td>
                        <td className='ncbol-cell-label'>SIT TOTAL {currency}</td><td className='ncbol-cell-val'><V value={sit.sit_total}/></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className='ncbol-charge-scroll'>
                <table className='table mb-0 mt-1 ncbol-charge-table'>
                    <thead>
                    <tr className='ncbol-black-head'>
                        <th colSpan={6}>PACKING AND ADDITIONAL CHARGES</th>
                    </tr>
                    <tr>
                        <th className='ncbol-cell-label'>Item</th>
                        <th className='ncbol-cell-label'>Qty</th>
                        <th className='ncbol-cell-label'>Rate</th>
                        <th className='ncbol-cell-label'>Charge</th>
                        <th className='ncbol-cell-label'>Item</th>
                        <th className='ncbol-cell-label'>Charge</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rows.map((row, idx) => (
                        <tr key={`p_${idx}`}>
                            <td className='ncbol-cell-val'>{row.packing_item}</td>
                            <td className='ncbol-cell-val'><V value={row.packing_qty}/></td>
                            <td className='ncbol-cell-val'><V value={row.packing_rate}/></td>
                            <td className='ncbol-cell-val'><V value={row.packing_charge}/></td>
                            <td className='ncbol-cell-val'>{row.additional_item || ''}</td>
                            <td className='ncbol-cell-val'>{row.additional_charge || ''}</td>
                        </tr>
                    ))}
                    <tr>
                        <td className='ncbol-cell-val'></td>
                        <td className='ncbol-cell-val'></td>
                        <td className='ncbol-cell-val'></td>
                        <td className='ncbol-cell-val'></td>
                        <td className='ncbol-cell-label'>Total Packing / Additional Charges</td>
                        <td className='ncbol-cell-val'><V value={packing.packing_total}/>/<V value={packing.additional_total}/></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className='ncbol-bottom-totals'>
                <div>TOTAL CHARGES: {currency}<V value={packing.total_charges}/></div>
                <div>PRE-PAYMENTS: {currency}<V value={packing.pre_payments}/></div>
                <div>AMOUNT DUE: {currency}<V value={packing.amount_due}/></div>
            </div>

            <div className='ncbol-move-notes'>
                <b>MOVE NOTES:</b> {summary.move_notes || ''}
            </div>
        </div>
    );
};
